import { render, staticRenderFns } from "./DevengadoDetallePage.vue?vue&type=template&id=d813d4e0"
import script from "./DevengadoDetallePage.js?vue&type=script&lang=js&external"
export * from "./DevengadoDetallePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports